<template>
	<div class="our-doctor">

		<section class="banner">
			<div class="img">
				<img :src="`${publicPath}images/ourheaddoctor_1.jpg`" class="desktop">
				<img :src="`${publicPath}images/m/ourheaddoctor_1_small.jpg`" class="mobile">
			</div>
			<div class="container">
				<div class="doctor-intro">
					<h1 v-html="$t('doctor1')"></h1>
					<p>{{ $t("doctor2") }}</p>
					<p>{{ $t("doctor3") }}</p>
				</div>
			</div>
		</section>

		<section class="about-doctor">
			<div class="container">
				<div class="education">

					<div class="list">
						<img :src="`${publicPath}images/education.png`">
						<h2>{{ $t("doctor4") }}</h2>
						<ul>
							<li>{{ $t("doctor5") }}</li>
							<li>{{ $t("doctor6") }}</li>
							<li>{{ $t("doctor7") }}</li>
							<li>{{ $t("doctor8") }}</li>
						</ul>
					</div>

					<!-- <div class="img mobile">
						<img :src="`${publicPath}images/ourheaddoctor_2.jpg`">
					</div> -->
				</div>

				<div class="medical">
					<img :src="`${publicPath}images/licensure.png`">
					<h2>{{ $t("doctor9") }}</h2>
					<ul>
						<li>{{ $t("doctor10") }}</li>
						<li>{{ $t("doctor11") }}</li>
						<li>{{ $t("doctor12") }}</li>
						<li>{{ $t("doctor13") }}</li>
						<li>{{ $t("doctor14") }}</li>
						<li>{{ $t("doctor15") }}</li>
						<li>{{ $t("doctor16") }}</li>
					</ul>
				</div>
			</div>
		</section>

		<footer>
			<div class="container">
				<div class="copyright">
					Copyright &copy; 2019 GraceMed. All Rights Reserved.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
	name: 'our-doctor',
	components: {
		
	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			mobileNav: false
		}
	},
	methods: {
		toggleMobileNav() {
			this.mobileNav = !this.mobileNav
		}
	}
}
</script>

<style>
.our-doctor .banner .img {
	position: relative;	
}

.our-doctor .banner img {
	width: 100%;
	max-width: 100%;
}

.doctor-intro {
	position: absolute;
	bottom: 10%;
	left: auto;
	text-align: left;
	width: 550px;
	color: #fff;
}

.doctor-intro h1 {
	position: relative;
	left: auto;
	bottom: auto;
}

.doctor-intro p {
	line-height: 1.6em;
}

.about-doctor h2 {
	font-weight: 100;
	margin: 0;
	padding: 0;
	text-transform: uppercase;
	font-family: "Times New Roman", Times, serif;
	letter-spacing: 5px;
	font-size: 2em;
	color: #9d937c;
	background: #fff;
	padding: 20px 0;
}

.zh .about-doctor h2 {
	font-weight: bold;
	font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
}

.about-doctor .education {
	position: relative;
	height:750px;
	z-index: 100;
}

.about-doctor .education h2 {
	
}

.about-doctor .education .list {
	position: absolute;
	width: 550px;
	right: 0;
	top: 120px;
	border: 7px solid #f39d007a;
	padding: 50px 50px 0 50px;
}

.about-doctor .education .list img {
	width: 150px;
	float: right;
}

.about-doctor .education .img {
	width: 400px;
	position: absolute;
	top: 230px;
	left: 30px;
}

.about-doctor .education .img img {
	width: 100%;
}

.about-doctor ul {
	border-left: 7px solid #d6c3b4;
	padding-bottom: 150px;
	margin-bottom: 0;
}

.about-doctor ul li {
	margin: 8px 0;
}

.about-doctor .medical {
	position: relative;
	background: #f1eae6;
	width: 80%;
	margin-top: -200px;
	display: block;
	z-index: 50;
}

.about-doctor .medical img {
	width: 125px;
	float: left;
	margin: 130px 20px 20px 100px;
}

.about-doctor .medical h2 {
	padding-top: 160px;
	background: none;
}

.about-doctor .medical ul {
	border-left: 7px solid #d6c3b4;
	margin-left: 230px;
	padding: 20px 50px;
	min-height: 300px;
	margin-bottom: 0;
}

@media handheld,only screen and (max-width: 800px) {
	.doctor-intro {
		position: relative;
		top: 0;
		left: 0;
		width: 95%;
		margin: auto;
		padding-bottom: 20px;
	}

	.doctor-intro h1 {
		font-size: 1.8em;
		margin: 25px auto 20px auto;
		padding: 0;
		text-align: center;
		color: #f39d00;
	}

	.doctor-intro p {
		color: #75787b;
		font-size: 0.9em;
	}

	.about-doctor .education {
		border: none;
		height: auto;
	}

	.about-doctor .education .img {
		width: 50%;
		left: inherit;
		right: 30px;
		top: 0;
		z-index: 10;
		margin-top: -53%;
	}

	.about-doctor .education .list {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		border: none;
		background: #f1eae6;
		margin-top: 40px;
		padding: 0;
		text-align: center;
		padding-bottom: 20px;
	}

	.about-doctor .education .list img {
		position: relative;
		z-index: 20;
		padding-top: 14%;
		width: 100px;
		float: none;
	}

	.about-doctor .education h2 {
		position: relative;
		background: none;
		font-size: 1.5em;
		top: 0;
		left: 0;
		padding: 5px;
	}

	.about-doctor .education .list ul {
		font-size: 0.9em;
		text-align: left;
		border: none;
		padding-bottom: 0;
	}

	.about-doctor .medical {
		margin: 0;
		background: #f1eae6;
		width: 100%;
		text-align: center;
		padding-bottom: 50px;
	}

	.about-doctor h2 {
		position: relative;
		background: none;
		font-size: 1.5em;
		top: 0;
		left: 0;
		padding: 5px 30px !important;

	}

	.about-doctor .medical img {
		width: 100px;
		float: none;
		margin: 20px 0 0 0;
	}

	.about-doctor .medical ul {
		border: none;
		min-height: auto;
		margin: 0;
		text-align: left;
		font-size: 0.9em;
	}
}

</style>